import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Home from './Home';
import Portfolios from './Portfolios';
import Portfolio from './Portfolio';
import Contact from './Contact';

import withTracker from '../withTracker';

class App extends Component {
  render(){
    return (
      <div>
        <Header />
        <Switch>
          <Route path="/portfolio/:portfolioId" component={withTracker(Portfolio)} />
          <Route path="/portfolios" component={withTracker(Portfolios)} />
          <Route path="/contact" component={withTracker(Contact)} />
          <Route path="/" component={withTracker(Home)} />
        </Switch>
        <Footer />
      </div>
    );
  }
}
export default App;


// WEBPACK FOOTER //
// ./src/components/App.js